module.exports = __webpack_public_path__ + "static/media/CBON - Community based organization Network Mobile - CBON - 22-11-2024 C.9432e8c9.gif";